/** Подгрузка сетки порциями: метка под сеткой просит следующую порцию у экрана. */

import { useEffect, useRef } from "react";

/** Плиток в порции сетки. */
export const PAGE = 120;

/** Добавить порцию, когда до метки под сеткой осталось столько. */
const AHEAD_PX = "1200px";

/**
 * Метка под сеткой: подъехала к экрану — просит следующую порцию. Владелец
 * пересоздаёт её на каждой порции (`key`), и новый наблюдатель сразу сообщает
 * текущее положение: если метка всё ещё у экрана (высокий монитор), порция
 * добавится снова, а не повиснет до следующей прокрутки.
 */
export function MoreOnScroll({ onMore, text }: { onMore: () => void; text: string }) {
  const mark = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = mark.current;
    if (!el) return;
    let fired = false;
    const observer = new IntersectionObserver(
      (entries) => {
        if (fired || !entries.some((e) => e.isIntersecting)) return;
        fired = true;
        onMore();
      },
      // Прокручивается `main`, а не окно: запас считаем от него.
      { root: el.closest("main"), rootMargin: AHEAD_PX },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [onMore]);
  return (
    <div ref={mark} className="pt-4 text-center text-[12px] text-fg-faint tnum" data-annot="подгрузка сетки">
      {text}
    </div>
  );
}
